import { useTranslation } from "react-i18next";

import InputField, {
    INPUT_FIELD_SIZES
} from "../../DesignComponents/InputField";
import { OtpInputFieldProps } from "../types";

export const OtpInputField = ({
    isLoading,
    error,
    onChange,
    label,
    isRequired
}: OtpInputFieldProps) => {
    const { t } = useTranslation();

    return (
        <InputField
            autoFocus
            autoComplete="one-time-code"
            fullWidth
            required={isRequired}
            readOnly={isLoading}
            errorText={error}
            labelLeft={
                label || t("Security##2FA##send otp code##six digit code")
            }
            placeholder={t("Dialog##enter")}
            size={INPUT_FIELD_SIZES.Medium}
            onChange={e => onChange(e.target.value)}
        />
    );
};
